import { useQuery } from "@tanstack/react-query";

import { guacHttpClient } from "@/lib/http";
import { HttpResponse, User } from "@/types";

export const usersQueryKey = () => ["users"] as const;

export function useGetUsers() {
  return useQuery({
    queryKey: usersQueryKey(),
    queryFn: async () => {
      const path = "/users";
      const res = await guacHttpClient.get<User[], HttpResponse<User[]>>(path);
      return res.data;
    },
  });
}
